// extracted by mini-css-extract-plugin
export default {"root":"ConfirmUserDeleteModal_root__88tPH","container":"ConfirmUserDeleteModal_container__HIpAS","footer":"ConfirmUserDeleteModal_footer__0bVgq"};